export const pathName = {
	"Home": "晋顺芯",
	"activityZone": "晋顺芯-分类名称",
	"goodsList": "晋顺芯-分类名称",
	"goodDetail": "晋顺芯-商品名称",
	"shoppingCart": "晋顺芯-我的购物车",
	"commitOrder": "晋顺芯-确认订单",
	"orderPay": "晋顺芯-收银台",
	"payOk": "晋顺芯-支付完成",
	"collect": "晋顺芯-关注/收藏",
	"editPassword": "晋顺芯-修改密码",
	"xindou": "晋顺芯-芯豆明细",
	"enterpriseCode": "晋顺芯-自定义编码",
	"memberInfo": "晋顺芯-成员信息",
	"addrManage": "晋顺芯-地址信息",
	"billInfo": "晋顺芯-发票信息",
	"bussinessInfo": "晋顺芯-基本信息",
	"brandCenter": "晋顺芯-品牌信息",
	"batchOrder": "晋顺芯-批量下单",
	"fastOrder": "晋顺芯-极速下单",
	"intellectQuotedPrice": "晋顺芯-智能下单",
	"authorization": "晋顺芯-授权查询",
	"myOrder": "晋顺芯-我的订单",
	"enterpriseSuit": "晋顺芯-自定义套装",
	"individualSuit": "晋顺芯-自定义套装",
	"individualCode": "晋顺芯-自定义编码",
	"goCompany": "关于晋顺芯",
	"shoppingFlow": "关于晋顺芯",
	"normalQuestion": "关于晋顺芯",
	"promotion": "关于晋顺芯",
	"billKnow": "关于晋顺芯",
	"howPay": "关于晋顺芯",
	"servicePolicy": "关于晋顺芯",
	"requestSuggest": "关于晋顺芯",
	"contact": "关于晋顺芯",
	"brandGoods": "晋顺芯-分类名称",
}



// WEBPACK FOOTER //
// ./src/router/pathName.js